import { createRouter, createWebHistory } from "vue-router";
import SignInView from "@/views/Login/SignInView.vue";
import HomeView from "@/views/HomeView.vue";
import AppDashboard from "@/views/Dashboard/DashboardView.vue";
import appUtilizadores from "@/views/Utilizador/utilizadoresView.vue";
import appFornecedor from "@/views/Fornecedor/fornecedorView.vue";
import appViaturas from "@/views/Viatura/viaturaView.vue";
import appSucursais from "@/views/Sucursal/sucursalView.vue";
import appContratos from "@/views/Contratos/contratosView.vue";
import appContratoDetalhe from "@/views/Contratos/contratoDetalheView.vue";
import appProdutos from "@/views/FamiliaProdutoTipologia/produtoView.vue";

import appContacto from "@/views/Contactos/contactoView.vue";
import appHistorico from "@/views/HistoricoView.vue";
import appConfiguracoes from "@/views/Configuracoes/configuracoesView.vue";
import appRoles from "@/views/Roles/rolesView.vue";
import appAgendar from "@/views/app_tecnico/myAgendarView.vue";
import appArmazens from "@/views/Armazem/armazensView.vue";
import appEquipamentos from "@/views/Equipamentos/equipamentosView.vue";
import appEquipamentosAssociar from "@/views/Equipamentos/equipamentosAssociarView .vue";
import appArtigos from "@/views/Artigos/artigosView.vue";
import appPlaneamento from "@/views/Planeamento/planeamentoView.vue";
import appPlaneamento2 from "@/views/Planeamento/planeamentoView2.vue";
import appOrdemServico from "@/views/Ordem_Servico/ordemServicoView.vue";
import appTabelaPreco from "@/views/TabelaPreco/tabelaPrecoView.vue";
import appContabilidade from "@/views/contabilidadeView.vue";
import appCallCenter from "@/views/callCenterView.vue";
import appChat from "@/views/chatView.vue";
import FlowChartComponent from "@/views/flow.vue";
import permissionMixin from "@/permissionMixin.js";
import NotFoundView from "@/views/NotFound/NotFoundView.vue";
import NotAuthorized from "@/views/NotAthorized/NotAuthorizedView.vue";

const mainRoutes = [
  {
    path: "/recuperar-password",
    name: "recuperarPassword",
    component: () =>
      import("@/views/RecuperarPassword/recuperarPAsswordView.vue"),
  },
  {
    // Recuperar password da área de cliente: empresa (schema) já fixada em safetypt
    path: "/cliente/recuperar-password",
    name: "recuperarPasswordCliente",
    component: () =>
      import("@/views/RecuperarPassword/recuperarPAsswordView.vue"),
    meta: { schema: "safetypt" },
  },
  {
    path: "/",
    name: "signin",
    component: SignInView,
  },
  {
    // Login da área de cliente: empresa (schema) já fixada em safetypt
    path: "/cliente/login",
    name: "signinCliente",
    component: () => import("@/views/Login/ClienteSignInView.vue"),
  },

  {
    path: "/tecnico",
    name: "tecnico",
    component: () => import("@/views/new_app_tecnico/TecnicoHomeView.vue"),
    children: [
      {
        path: "localinstalacao/:order_id",
        name: "localinstalacao",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoLocalInstalacaoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "IT0001",
        },
      },
      {
        path: "contactos",
        name: "contactos",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoContactosView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "NT0001",
        },
      },
      {
        path: "dashboard",
        name: "tecnicodashboard",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoDashboardView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "HT0001",
        },
      },
      {
        path: "planeamento",
        name: "planeamento",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoPlaneamentoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "MT0001",
        },
      },
      {
        path: "servicos",
        name: "servicos",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoServiceView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ST0001",
        },
      },
      {
        path: "stocks",
        name: "stocks",
        component: () => import("@/views/new_app_tecnico/TecnicoStockView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ST0001",
        },
      },
      
      {
        path: "fechar/execucao/:order_id",
        name: "fecharexecucao",
        component: () =>
          import("@/views/new_app_tecnico/FecharExecucaoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ET0002",
        },
      },
      {
        path: "execucoes/:order_id",
        name: "texecucao",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoExecucaoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ET0001",
        },
      },
      {
        path: "execucoes-grelha/:order_id",
        name: "grelhaexecucao",
        component: () =>
          import("@/views/new_app_tecnico/TecnicoGrelha.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ET0001",
        },
      },
      {
        path: "pesquisa-artigo",
        name: "tecnicopesquisaartigo",
        component: () => import("@/views/PesquisaArtigo.vue"),
        meta: {
          requiresAuth: true,
          codigo: "ET0001",
        },
      },
    ],
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: AppDashboard,
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      // {
      //   path: "clientes",
      //   name: "clientes",
      //   component: () => import("@/views/Cliente/clienteView.vue"),
      //   meta: {
      //     requiresAuth: true,
      //     codigo: "L0001", // Código para sub-cliente
      //   },
      // },
      // Área de clientes: cada nível tem rota própria (com id opcional) para
      // que o clique numa linha fique no histórico e o retroceder do browser
      // volte à listagem correta.
      {
        path: "clientes/:clienteId(\\d+)?",
        name: "clientes",
        component: () => import("@/views/Cliente/clientManager.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001", // Código para sub-cliente
        },
      },
      {
        path: "subclientes/:subClienteId(\\d+)?",
        name: "subclientes",
        component: () => import("@/views/Cliente/clientManager.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
      {
        path: "instalacoes/:instalacaoId(\\d+)?",
        name: "instalacoes",
        component: () => import("@/views/Cliente/clientManager.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
      {
        path: "instalacoes/:instalacaoId(\\d+)/artigos",
        name: "instalacao-artigos",
        component: () => import("@/views/Cliente/clientManager.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },

      // Rotas para Aplicacao dos Clientes
      {
        path: "my-subcliente",
        name: "my-subcliente",
        component: () => import("@/views/app_client/mySubClienteView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      {
        path: "my-local",
        name: "my-local",
        component: () => import("@/views/app_client/myLocalInstalacaoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-pedidos",
        name: "my-pedidos",
        component: () => import("@/views/app_client/myPedidoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-propostas",
        name: "my-propostas",
        component: () => import("@/views/app_client/myPropostaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-orcamentos",
        name: "my-orcamentos",
        component: () => import("@/views/app_client/myOrcamentoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      {
        path: "my-encomendas",
        name: "my-encomendas",
        component: () => import("@/views/app_client/myEncomendaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      {
        path: "my-agendamentos",
        name: "my-agendamentos",
        component: () => import("@/views/app_client/myAgendamentoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      {
        path: "my-relatorios",
        name: "my-relatorios",
        component: () => import("@/views/app_client/myRelatorioView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-faturas",
        name: "my-faturas",
        component: () => import("@/views/app_client/myFaturaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-artigos",
        name: "my-artigos",
        component: () => import("@/views/app_client/myArtigoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "my-contactos",
        name: "my-contactos",
        component: () => import("@/views/app_client/myContactoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "/my-mapas",
        name: "my-mapas",
        component: () => import("@/views/app_client/myMapaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "/my-tabela_preco",
        name: "my-tabela_preco",
        component: () => import("@/views/app_client/myTabelaPrecoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "/my-plantas",
        name: "my-plantas",
        component: () => import("@/views/app_client/myPlantaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },
      {
        path: "/my-reports-old",
        name: "my-reports-old",
        component: () => import("@/views/app_client/myReportsOldView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      {
        path: "/my-perfil",
        name: "my-perfil",
        component: () => import("@/views/app_client/myPerfilView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "H0001",
        },
      },

      // Fim das rotas para aplicacao dos clientes

      // Rotas para aplicacao normal

      {
        path: "configuracoes",
        name: "configuracoes",
        component: appConfiguracoes,
        meta: {
          requiresAuth: true,
          codigo: "C0001",
        },
      },
      {
        path: "roles",
        name: "roles",
        component: appRoles,
        meta: {
          requiresAuth: true,
          codigo: "R0001",
        },
      },

      {
        path: "utilizadores",
        name: "utilizadores",
        component: appUtilizadores,
        meta: {
          requiresAuth: true,
          codigo: "U0001",
        },
      },
      {
        path: "agendar",
        name: "agendar",
        component: appAgendar,
        meta: {
          requiresAuth: true,
          codigo: "U0001",
        },
      },

      {
        path: "fornecedores",
        name: "fornecedores",
        component: appFornecedor,
        meta: {
          requiresAuth: true,
          codigo: "F0001",
        },
      },
      {
        path: "armazens",
        name: "armazens",
        component: appArmazens,
        meta: {
          requiresAuth: true,
          codigo: "A0001",
        },
      },
      {
        path: "armazens/:armazem_id",
        name: "armazens-with-id",
        component: appArmazens,
        meta: {
          requiresAuth: true,
          codigo: "A0001",
        },
      },
      {
        path: "viaturas",
        name: "viaturas",
        component: appViaturas,
        meta: {
          requiresAuth: true,
          codigo: "V0001",
        },
      },
      {
        path: "sucursais",
        name: "sucursais",
        component: appSucursais,
        meta: {
          requiresAuth: true,
          codigo: "SU0001",
        },
      },
      {
        path: "contratos",
        name: "contratos",
        component: appContratos,
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
      {
        path: "contratos/:id",
        name: "contrato-detalhe",
        component: appContratoDetalhe,
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
      {
        path: "familia",
        name: "familia",
        component: appProdutos,
        meta: {
          requiresAuth: true,
          codigo: "P0001",
        },
      },
      {
        path: "equipamentos",
        name: "equipamentos",
        component: appEquipamentos,
        meta: {
          requiresAuth: true,
          codigo: "E0001",
        },
      },
      {
        path: "associar",
        name: "associar",
        component: appEquipamentosAssociar,
        meta: {
          requiresAuth: true,
          codigo: "E0001",
        },
      },
      {
        path: "detalhes_negocio/:id",
        name: "detalhes_negocio",
        component: () => import("@/views/Negocio/detalhesNegocioView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
        },
      },
      {
        path: "negocio-kanban",
        name: "negocio-kanban",
        component: () => import("@/views/Negocio/NegocioKanbanView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
        },
      },
      {
        path: "negocio",
        name: "negocio",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          // Colunas próprias da listagem de Negócios: nº da proposta, armazém
          // da zona do local, gestor e comercial do cliente
          colunasNegocio: true,
          // O nº da proposta fica visível nesta listagem, por isso a barra de
          // pesquisa também o procura
          pesquisaOrcamentoId: true,
        },
      },
      {
        path: "negocio/:negocio_id",
        name: "negocio-with-id",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          // Mesma listagem de /negocio, com o detalhe aberto
          colunasNegocio: true,
          pesquisaOrcamentoId: true,
        },
      },
      // Orçamentação: mesma página dos negócios, limitada às etapas iniciais
      {
        path: "orcamentacao",
        name: "orcamentacao",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Orçamentação",
          restrictStages: ["pedido", "proposta", "orcamento"],
          // O filtro de Estado só oferece as etapas desta página
          filterStatuses: ["pedido", "proposta", "orcamento"],
          // Estes filtros são análises que atravessam a pipeline (ex.: quantos
          // orçamentos foram adjudicados, já em Financeiro): quando estão
          // preenchidos, a restrição de etapa da página é ignorada.
          filtrosIgnoramEtapa: ["status", "orcamento_estado_id"],
          showEtapaOrcamentoFiltros: true,
          // A barra de pesquisa da tabela também aceita o nº do orçamento
          pesquisaOrcamentoId: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          colunasNegocio: true,
          // Sem criação rápida nesta página
          esconderCriarNegocioRapido: true,
          detailRouteName: "orcamentacao-with-id",
        },
      },
      {
        path: "orcamentacao/:negocio_id",
        name: "orcamentacao-with-id",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Orçamentação",
          restrictStages: ["pedido", "proposta", "orcamento"],
          // O filtro de Estado só oferece as etapas desta página
          filterStatuses: ["pedido", "proposta", "orcamento"],
          // Estes filtros são análises que atravessam a pipeline (ex.: quantos
          // orçamentos foram adjudicados, já em Financeiro): quando estão
          // preenchidos, a restrição de etapa da página é ignorada.
          filtrosIgnoramEtapa: ["status", "orcamento_estado_id"],
          showEtapaOrcamentoFiltros: true,
          // A barra de pesquisa da tabela também aceita o nº do orçamento
          pesquisaOrcamentoId: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          colunasNegocio: true,
          // Sem criação rápida nesta página
          esconderCriarNegocioRapido: true,
          detailRouteName: "orcamentacao-with-id",
        },
      },
      // Adjudicação: etapas da pipeline a partir do Financeiro (restrictStages
      // porque a Execução não é um status — deriva das ordens de serviço)
      {
        path: "adjudicacao",
        name: "adjudicacao",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Adjudicação",
          // Só Financeiro e Gestão de Produção: Previsto e Execução/Planeamento
          // têm agora páginas próprias
          restrictStages: ["encomenda", "armazem"],
          // Nesta etapa não se cria um negócio de raiz, só o negócio rápido
          esconderCriarNegocio: true,
          // Etapas fora da adjudicação: não fazem sentido no filtro de Estado
          // ('ativo' é a etapa Pedido, ver negocioStatusLabel)
          excludeStatuses: [
            "ativo",
            "pedido",
            "proposta",
            "orcamento",
            "perdido",
            "fechado",
            "validacao",
            "planeamento",
          ],
          // Escolher um Estado (ex.: Material Encomendado, fora do âmbito da
          // página) sobrepõe-se à restrição de etapa, senão não devolvia nada
          filtrosIgnoramEtapa: ["status"],
          showEtapaAdjudicacaoFiltros: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          detailRouteName: "adjudicacao-with-id",
        },
      },
      {
        path: "adjudicacao/:negocio_id",
        name: "adjudicacao-with-id",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Adjudicação",
          // Só Financeiro e Gestão de Produção: Previsto e Execução/Planeamento
          // têm agora páginas próprias
          restrictStages: ["encomenda", "armazem"],
          // Nesta etapa não se cria um negócio de raiz, só o negócio rápido
          esconderCriarNegocio: true,
          // Etapas fora da adjudicação: não fazem sentido no filtro de Estado
          // ('ativo' é a etapa Pedido, ver negocioStatusLabel)
          excludeStatuses: [
            "ativo",
            "pedido",
            "proposta",
            "orcamento",
            "perdido",
            "fechado",
            "validacao",
            "planeamento",
          ],
          // Escolher um Estado (ex.: Material Encomendado, fora do âmbito da
          // página) sobrepõe-se à restrição de etapa, senão não devolvia nada
          filtrosIgnoramEtapa: ["status"],
          showEtapaAdjudicacaoFiltros: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          detailRouteName: "adjudicacao-with-id",
        },
      },
      // Previsto: etapa Previsto da pipeline + negócios já em planeamento mas
      // ainda sem técnico atribuído (ver extra_stage_filters no backend)
      {
        path: "previsto",
        name: "previsto",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Previsto",
          pageNote:
            'Negócios na etapa previsto e planeamento. Correspondem ao "Aberto" e "Pendente" da safetyprod. Serviços ainda sem técnico atribuído.',
          restrictStages: ["previsto", "planeamento_sem_tecnico"],
          // A página só tem estes dois estados; o resto não faz sentido no filtro
          filterStatuses: ["validacao", "planeamento"],
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          detailRouteName: "previsto-with-id",
          // Previsto não cria negócios de raiz, nem sequer o rápido: os
          // negócios já vêm de etapas anteriores (adjudicação/encomenda).
          esconderCriarNegocio: true,
          esconderCriarNegocioRapido: true,
          // Exceção: criar um negócio que entra logo no Previsto, sem as etapas
          // anteriores (só Negocio + Validacao vazia)
          criarPrevisto: true,
        },
      },
      {
        path: "previsto/:negocio_id",
        name: "previsto-with-id",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Previsto",
          pageNote:
            'Negócios na etapa previsto e planeamento. Correspondem ao "Aberto" e "Pendente" da safetyprod',
          restrictStages: ["previsto", "planeamento_sem_tecnico"],
          // A página só tem estes dois estados; o resto não faz sentido no filtro
          filterStatuses: ["validacao", "planeamento"],
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          detailRouteName: "previsto-with-id",
          esconderCriarNegocio: true,
          esconderCriarNegocioRapido: true,
          criarPrevisto: true,
        },
      },
      // Execução: etapa Execução da pipeline já agendada, ou seja, o que aparece
      // no calendário do planeamento (OS com planeamento vivo e técnico)
      {
        path: "execucao",
        name: "execucao",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Execução/Operação",
          pageNote:
            "Negócios no estado de planeamento e fechado. Negócios já com OS com tecnico atribuído, alocado ou serviço fechado/executado",
          restrictStages: ["execucao_agendada"],
          filterStatuses: ["planeamento", "validacao", "fechado"],
          // Acrescenta as colunas das ordens de serviço à tabela e o filtro
          // pelo estado da OS
          colunasOrdemServico: true,
          showEtapaExecucaoFiltros: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          // Os negócios chegam aqui já de etapas anteriores: não se
          // criam nesta página, nem de raiz nem pelo rápido
          esconderCriarNegocio: true,
          esconderCriarNegocioRapido: true,
          detailRouteName: "execucao-with-id",
        },
      },
      {
        path: "execucao/:negocio_id",
        name: "execucao-with-id",
        component: () => import("@/views/Negocio/negocioView2.vue"),
        meta: {
          requiresAuth: true,
          codigo: "O0001",
          pageTitle: "Execução/Operação",
          pageNote:
            "Negócios no estado de planeamento e fechado. Negócios já com OS com tecnico atribuído, alocado ou fechado/executado",
          restrictStages: ["execucao_agendada"],
          filterStatuses: ["planeamento", "validacao", "fechado"],
          // Acrescenta as colunas das ordens de serviço à tabela e o filtro
          // pelo estado da OS
          colunasOrdemServico: true,
          showEtapaExecucaoFiltros: true,
          // Colunas e filtros do nº/valor da proposta, armazém da zona,
          // gestor e comercial — os mesmos da listagem de Negócios
          pesquisaOrcamentoId: true,
          colunasNegocio: true,
          // Os negócios chegam aqui já de etapas anteriores: não se
          // criam nesta página, nem de raiz nem pelo rápido
          esconderCriarNegocio: true,
          esconderCriarNegocioRapido: true,
          detailRouteName: "execucao-with-id",
        },
      },
      {
        path: "negocioextra",
        name: "negocioextra",
        component: () => import("@/views/Negocio/negocioExtra.vue"),
        meta: {
          requiresAuth: true,
          codigo: "OE0001",
        },
      },
      {
        path: "negocioextra/:negocio_id",
        name: "negocioextra-with-id",
        component: () => import("@/views/Negocio/negocioExtra.vue"),
        meta: {
          requiresAuth: true,
          codigo: "OE0001",
        },
      },
      {
        path: "stocks",
        name: "stocks-backoffice",
        component: () => import("@/views/Stock/stockView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "SM0001",
        },
      },
      {
        path: "stocks/entrada/:entrada_estoque_id",
        name: "entradaartigo",
        component: () => import("@/components/stock/entrada/EntradaArtigo.vue"),
        meta: {
          requiresAuth: true,
          codigo: "SM0001",
        },
      },
      {
        path: "stocks/movimento/:movimento_estoque_id",
        name: "movimentoartigo",
        component: () => import("@/components/stock/movimento/MovimentoArtigo.vue"),
        meta: {
          requiresAuth: true,
          codigo: "SM0001",
        },
      },
      {
        path: "contacto",
        name: "contacto",
        component: appContacto,
        meta: {
          requiresAuth: true,
          codigo: "N0001",
        },
      },
      {
        path: "historico",
        name: "historico",
        component: appHistorico,
        meta: {
          requiresAuth: true,
          codigo: "K0001",
        },
      },
      {
        path: "documentacao",
        name: "documentacao",
        component: () => import("@/views/Documentacao/DocumentacaoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "I0001",
        },
      },
      {
        path: "artigos",
        name: "artigos",
        component: appArtigos,
        meta: {
          requiresAuth: true,
          codigo: "G0001",
        },
      },

      {
        path: "planeamentos",
        name: "planeamentos",
        component: appPlaneamento,
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "planeamentos2",
        name: "planeamentos2",
        component: appPlaneamento2,
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "mapaServicos",
        name: "mapaServicos",
        component: () => import("@/views/Mapa/mapaServicosView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "planeamentoAutomatico",
        name: "planeamentoAutomatico",
        component: () => import("@/views/PlaneamentoAutomatico/PlaneamentoAutomaticoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "analise",
        name: "analise",
        component: () => import("@/views/Analise/AnaliseView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "K0001",
        },
      },

      {
        path: "explorar",
        name: "explorar",
        component: () => import("@/views/Analise/ExplorarView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "K0001",
        },
      },

      {
        path: "analiseTecnico",
        name: "analiseTecnico",
        component: () => import("@/views/Analise/analiseTecnicoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "historicoOrdensServico",
        name: "historicoOrdensServico",
        component: () => import("@/views/Ordem_Servico/OrdemServicoHistoricoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "M0001",
        },
      },

      {
        path: "correcaoTecnico",
        name: "correcaoTecnico",
        component: () => import("@/views/CorrecaoTecnico/CorrecaoTecnicoView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "CT0001",
        },
      },

      {
        path: "correcaoTecnico/:order_id",
        name: "correcaoTecnicoGrelha",
        component: () => import("@/views/CorrecaoTecnico/CorrecaoTecnicoGrelhaView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "CT0001",
        },
      },

      {
        path: "ordemServico",
        name: "ordemServico",
        component: appOrdemServico,
        meta: {
          requiresAuth: true,
          codigo: "S0001",
        },
      },
      {
        path: "ordemServico/:ordem_id/detalhes",
        name: "ordemDetalhes",
        component: () => import("@/views/Ordem_Servico/OrdemDetalhesView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "S0001",
        },
      },
      {
        path: "ordemServico/:ordem_id/fotos",
        name: "ordemFotos",
        component: () => import("@/views/Ordem_Servico/OrdemFotosView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "S0001",
        },
      },
      {
        path: "exportacoes",
        name: "exportacoes",
        component: () => import("@/views/Exportacoes/exportacoesView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "S0001",
        },
      },
      {
        path: "novidades",
        name: "novidades",
        component: () => import("@/views/ReleaseNotes/ReleaseNotesView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "RN0001",
        },
      },
      {
        path: "notificarAgendamentos",
        name: "notificarAgendamentos",
        component: () => import("@/views/Email/envioEmailView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "NS0001",
        },
      },
      {
        path: "reenviarAgendamentos",
        name: "reenviarAgendamentos",
        component: () => import("@/views/Email/reenvioEmailView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "NS0001",
        },
      },
      {
        path: "tabelaPrecos",
        name: "tabelaPrecos",
        component: appTabelaPreco,
        meta: {
          requiresAuth: true,
          codigo: "B0001",
        },
      },
      {
        path: "contabilidade",
        name: "contabilidade",
        component: appContabilidade,
        meta: {
          requiresAuth: true,
          codigo: "D0001",
        },
      },
      {
        path: "callCenter",
        name: "callCenter",
        component: appCallCenter,
        meta: {
          requiresAuth: true,
          codigo: "T0001",
        },
      },

      {
        path: "messages",
        name: "chat",
        component: appChat,
        meta: {
          requiresAuth: true,
          codigo: "J0001",
        },
      },
      {
        path: "flowchart",
        name: "flowchart",
        component: FlowChartComponent,
        meta: {
          requiresAuth: true,
          codigo: "J0001",
        },
      },
      {
        path: "pesquisa-artigo",
        name: "pesquisa-artigo",
        component: () => import("@/views/PesquisaArtigo.vue"),
        meta: {
          requiresAuth: true,
          codigo: "GP0001",
        },
      },
      {
        path: "transferencia-artigos",
        name: "transferencia-artigos",
        component: () => import("@/views/Artigos/transferenciaArtigosView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "G0001",
        },
      },
      {
        path: "recolhas-pendentes",
        name: "recolhas-pendentes",
        component: () => import("@/views/Recolha/RecolhaPendenteView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "G0001",
        },
      },
      {
        path: "transferencia-instalacoes",
        name: "transferencia-instalacoes",
        component: () => import("@/views/Cliente/transferenciaInstalacoesView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
      {
        path: "transferencia-subclientes",
        name: "transferencia-subclientes",
        component: () => import("@/views/Cliente/transferenciaSubClientesView.vue"),
        meta: {
          requiresAuth: true,
          codigo: "L0001",
        },
      },
    ],

    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/ordem-servico/responder/:token",
    name: "OrdemServicoResponse",
    component: () => import("@/views/OrdemServicoResponse.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/ordem-servico/acompanhar/:token",
    name: "OrdemServicoTracker",
    component: () => import("@/views/OrdemServicoTracker.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    // Link do email enviado ao cliente no fecho da OS: resumo + relatório/termo
    path: "/intervencao/:token",
    name: "IntervencaoResumo",
    component: () => import("@/views/IntervencaoResumoView.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/localizacao/tecnico/:tecnicoId",
    name: "LocalizacaoTecnico",
    component: () => import("@/components/mapa_localizacao_tecnico.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    // Página de teste do tracker GPS nativo (só funciona dentro da app Android)
    path: "/trackerTeste",
    name: "trackerTeste",
    component: () => import("@/views/Tracker/trackerTesteView.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/localizacao/tecnicos",
    name: "LocalizacaoTecnicos",
    component: () => import("@/components/mapa_localizacao_tecnicos_all.vue"),
    meta: {
      requiresAuth: false,
    },
  },

  {
    path: "/not-authorized",
    name: "NotAuthorized",
    component: NotAuthorized,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFoundView,
  },
];

const routes = [...mainRoutes];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  // If already logged in, skip the login page
  if (
    to.name === "signin" ||
    to.name === "signinCliente" ||
    to.name === "ForgotPassword"
  ) {
    if (JSON.parse(localStorage.getItem("isLoggedIn"))) {
      // Mesma verificação que o SignInView.vue faz no login explícito — sem
      // isto, um técnico que reabre a app sem passar pelo formulário (sessão
      // ainda válida, o token não expira) caía sempre no dashboard de admin,
      // e a TecnicoHomeView (onde o tracker GPS arranca) nunca montava.
      let tipo = null;
      try {
        tipo = JSON.parse(localStorage.getItem("tipo"));
      } catch {
        tipo = localStorage.getItem("tipo");
      }
      const isTechnician = typeof tipo === "object" ? tipo?.nome === "tecnico" : tipo === "tecnico";
      next({ name: isTechnician ? "tecnicodashboard" : "dashboard" });
    } else {
      next();
    }
    return;
  }

  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if the user is not logged in
    if (!JSON.parse(localStorage.getItem("isLoggedIn"))) {
      // If the user is not logged in, redirect to the signin page
      next({ name: "signin" });
    } else {
      // If the user is logged in, check if the user has permission to access the route
      const codigo = to.meta.codigo; // Retrieve the codigo from the route's meta property
      const hasPermission = permissionMixin.methods.validPermission(codigo);

      if (hasPermission) {
        // If the user has permission, allow access to the route
        next();
      } else {
        // Redirect to 'NotAuthorized' page
        next({ name: "NotAuthorized" });
        // next();
      }
    }
  } else {
    // If the route does not require authentication, allow access to the route
    next();
  }
});

// Handle lazy-loaded chunk failures after a new deploy.
// When the app was loaded before a deploy, navigating to a route whose chunk
// hash no longer exists on the server triggers a ChunkLoadError (or a
// "Unexpected token '<'" SyntaxError, because the server returns index.html
// for the missing .js). In that case we force a single reload so the browser
// fetches the fresh index.html with the new chunk hashes.
router.onError((error, to) => {
  const message = error?.message || "";
  const isChunkError =
    error?.name === "ChunkLoadError" ||
    /Loading( CSS)? chunk \d+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Unexpected token '<'/i.test(message);

  if (!isChunkError) {
    return;
  }

  // Guard against reload loops: only reload once per session for this case.
  const reloadKey = "chunkReloadAttempted";
  if (!sessionStorage.getItem(reloadKey)) {
    sessionStorage.setItem(reloadKey, "1");
    const target = to?.fullPath || window.location.pathname;
    window.location.assign(target);
  }
});

// Clear the reload guard once a navigation succeeds, so future deploys can
// trigger a fresh reload again.
router.afterEach(() => {
  sessionStorage.removeItem("chunkReloadAttempted");
});

export default router;
